import { Component } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs/operators";
import { LoaderService } from "./loader.service";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
  standalone: true
})
export class LoaderComponent {
  show = toSignal(
    this.loaderService.total$.pipe(map((total) => total > 0)),
    { initialValue: false }
  );

  constructor(private loaderService: LoaderService) {}
}
